var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 60,
    viewBox: "0 0 94 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0,0H94V60H0Z",
    transform: "translate(164 428)",
    fill: "#c7cdd1",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7839",
    "data-name": "Rectangle 7839",
    width: 51.009,
    height: 32.152,
    transform: "translate(21.496 13.924)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "integration_tools_-_merchants",
    "data-name": "integration tools - merchants",
    transform: "translate(-164 -428)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32370",
    "data-name": "Group 32370",
    transform: "translate(164 428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32370-2",
    "data-name": "Group 32370",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34563",
    "data-name": "Path 34563",
    d: "M37.577,13.924a15.97,15.97,0,0,1,7.613,1.921,18.051,18.051,0,0,0,0,28.321,16.079,16.079,0,1,1-7.613-30.242",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34564",
    "data-name": "Path 34564",
    d: "M56.424,13.924a15.966,15.966,0,0,0-7.6,1.921,18.051,18.051,0,0,1,0,28.321,16.077,16.077,0,1,0,7.6-30.242",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34565",
    "data-name": "Path 34565",
    d: "M47.011,17.108a15.946,15.946,0,0,0,0,25.793,15.96,15.96,0,0,0,0-25.793",
    fill: "#5048bf"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationTools);
export default __webpack_public_path__ + "static/media/integration_tools.9321f4591b8c4c75e01cd0f217dc5705.svg";
export { ForwardRef as ReactComponent };